export const getImage = (image: string) => {
  return image.includes('&format=pdf')
    ? { type: 'file', url: '/assets/img/pdf.png' }
    : { type: 'image', url: image }
}